<template>
  <b-container fluid>
    <tenant-info />
    <!-- Tenant and related Clients -->
    <b-row
      class="justify-content-between"
      cols="auto"
      md="auto"
      lg="auto"
    >
      <b-col>
        <b-table
          id="Clients"
          primary-key="id"
          head-variant="light"
          fixed
          small
          responsive
          :busy="isLoading"
          :items="clients"
          :fields="fields"
          :per-page="selectedPageSize"
          :total-rows="rows"
          :current-page="currentPage"
          @filtered="onFiltered"
        >
          <template
            slot="enabled"
            slot-scope="row"
          >
            <div v-if="row.item.enabled === true">
              <i
                v-b-tooltip.hover.left
                class="fa fa-circle o-enabled"
                title="Enabled"
              />
            </div>
            <div v-else>
              <i
                v-b-tooltip.hover.left
                class="fa fa-circle o-disabled"
                title="Disabled"
              />
            </div>
          </template>
          <template
            slot="edit"
            slot-scope="row"
          >
            <b-button
              v-b-tooltip.hover.left
              variant="link"
              class="px-0 py-1"
              title="Edit Client"
              @click="editClient(row.item)"
            >
              <i class="fa fa-pencil" />
            </b-button>
          </template>
          <template
            slot="delete"
            slot-scope="row"
          >
            <b-button
              v-b-tooltip.hover.left
              variant="link"
              class="px-0 py-1"
              title="Delete Resource"
              @click="deleteClient(row.item)"
            >
              <i class="fa fa-trash" />
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row v-show="isLoading === false">
      <b-col
        cols="auto"
        class="pr-2"
      >
        <b-pagination
          v-model="currentPage"
          size="sm"
          :total-rows="rows"
          :per-page="selectedPageSize"
          aria-controls="apiResources"
        />
      </b-col>
      <b-col
        cols="auto"
        class="mr-sm-auto mr-lg-0 o-page-count"
      >
        OF&nbsp;
        <span class="o-strong">{{ pageCount }}</span>
      </b-col>
      <b-col
        sm="12"
        lg="auto"
        class="o-page-size"
      >
        <b-form-group>
          <b-select
            id="pageSize"
            :value="selectedPageSize"
            class="ml-0 ml-lg-2"
            style="width: 65px;"
            :options="options"
            size="sm"
            @input="updatePageSize"
          />
          <label
            class="mr-3"
            for="pageSize"
          >PER PAGE</label>
        </b-form-group>
      </b-col>
    </b-row>

    <b-alert
      v-model="showAlert"
      variant="danger"
      dismissible
    >
      {{ alertMessage }}
    </b-alert>
  </b-container>
</template>

<script>
import TenantInfo from "./TenantInfo.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ClientList",
  components: {
    TenantInfo
  },
  data() {
    return {
      totalRows: 1,
      clients: [],
      loading: true,
      fields: [
        { key: "clientId", thClass: "text-truncate", tdClass: "text-truncate" },
        {
          key: "clientName",
          thClass: "text-truncate",
          tdClass: "text-truncate"
        },
        {
          key: "enabled",
          label: "",
          thClass: "o-th",
          tdClass: "o-td-center"
        },
        {
          key: "edit",
          label: "",
          thClass: "o-th",
          tdClass: "o-td-center"
        },
        {
          key: "delete",
          label: "",
          thClass: "o-th",
          tdClass: "o-td-center"
        }
      ],
      options: [
        { value: 5, text: "5" },
        { value: 10, text: "10" },
        { value: 15, text: "15" },
        { value: 20, text: "20" },
        { value: 30, text: "30" },
        { value: 50, text: "50" }
      ]
    };
  },
  computed: {
    ...mapGetters({
      isLoading: "isLoading",
      selectedPageSize: "clientListPageSize"
    }),
    showAlert: {
      get() {
        return this.$store.getters.showAlert;
      },
      set(value) {
        this.$store.dispatch("showAlert", value);
      }
    },
    alertMessage: {
      get() {
        return this.$store.getters.alertMessage;
      },
      set(value) {
        this.$store.dispatch("alertMessage", value);
      }
    },
    currentPage: {
      get() {
        return this.$store.getters.clientListCurrentPage;
      },
      set(value) {
        this.$store.dispatch("clientListCurrentPage", value);
      }
    },
    selectedPageSize: {
      get() {
        return this.$store.getters.clientListPageSize;
      },
      set(value) {
        this.$store.dispatch("clientListPageSize", value);
      }
    },
    rows() {
      return this.totalRows;
    },
    pageCount() {
      let totalPages = Math.floor(
        Number(this.rows) / Number(this.selectedPageSize)
      );
      if (Number(this.rows) % Number(this.selectedPageSize) != 0) totalPages++;
      return totalPages;
    },
    listFooter() {
      let recordFrom = (this.currentPage - 1) * this.selectedPageSize + 1;
      let recordTo = this.currentPage * this.selectedPageSize;
      recordTo = recordTo > this.rows ? this.rows : recordTo;
      return `Records: [${recordFrom} - ${recordTo}] of ${this.rows} Total`;
    }
  },
  mounted() {
    this.loadClientList();
  },
  methods: {
    ...mapActions({
      updatePageSize: "clientListPageSize"
    }),
    loadClientList() {
      this.$axios
        .get(`/api/tenants/${this.$route.params.tenantId}/clients`)
        .then(response => {
          this.clients = response.data;
          this.totalRows = this.clients.length;
        })
        .catch(error => {
          this.alertMessage = error;
        });
    },
    editClient(item) {
      this.$router.push({
        path: `clients/${item.id}/edit`
      });
    },
    deleteClient(item) {
      this.dialogResult = "";
      let msg = `Continue to delete ${item.clientName}?`;
      this.$bvModal
        .msgBoxConfirm(msg, {
          title: "Please Confirm",
          size: "lg",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value === true) {
            this.$axios
              .delete(
                `/api/tenants/${this.$route.params.tenantId}/clients/${item.id}/delete`
              )
              .then(() => {
                this.clients = this.clients.filter(t => t.id != item.id);
              })
              .catch(error => {
                this.alertMessage = error;
              });
          }
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows =
        this.filter === "" ? this.clients.length : filteredItems.length;
    }
  }
};
</script>
